<template>
  <div class="app-layout">
    <!-- 侧边栏 -->
    <aside class="sidebar" :class="{ 'sidebar-collapsed': isCollapsed }">
      <div class="logo-area">
        <img :src="shopLogo" alt="logo" class="logo-img" />
        <span class="logo-text" v-show="!isCollapsed">{{ shopName }}</span>
      </div>

      <div class="sidebar-menu-wrapper">
        <el-menu :default-active="activeMenu" :collapse="isCollapsed" :collapse-transition="false" router
          class="sidebar-menu">

          <!-- 1. 数据看板 -->
          <el-menu-item index="/dashboard">
            <el-icon>
              <Odometer />
            </el-icon>
            <span>数据看板</span>
          </el-menu-item>

          <!-- 2. 门店管理 -->
          <el-sub-menu index="store-group">
            <template #title>
              <el-icon>
                <Shop />
              </el-icon>
              <span>门店管理</span>
            </template>
            <el-menu-item index="/store">门店列表</el-menu-item>
            <el-menu-item index="/store-branch">分店管理</el-menu-item>
          </el-sub-menu>

          <!-- 3. 商品管理 -->
          <el-sub-menu index="product-group">
            <template #title>
              <el-icon>
                <Goods />
              </el-icon>
              <span>商品管理</span>
            </template>
            <el-menu-item index="/product/category">商品分类</el-menu-item>
            <el-menu-item index="/product/list">商品列表</el-menu-item>
            <el-menu-item index="/product/add">添加商品</el-menu-item>
            <el-menu-item index="/product-spec">商品规格</el-menu-item>
          </el-sub-menu>

          <!-- 4. 订单管理 -->
          <el-menu-item index="/order">
            <el-icon>
              <Document />
            </el-icon>
            <span>订单管理</span>
          </el-menu-item>

          <!-- 5. 核销记录 -->
          <el-menu-item index="/verification-record">
            <el-icon>
              <Checked />
            </el-icon>
            <span>核销记录</span>
          </el-menu-item>

          <!-- 6. 营销中心 -->
          <!-- 在营销中心 sub-menu 中添加绿书营销菜单 -->
          <el-sub-menu index="marketing-group">
            <template #title>
              <el-icon>
                <Present />
              </el-icon>
              <span>营销中心</span>
            </template>
            <el-menu-item index="/marketing/activity">活动管理</el-menu-item>
            <el-menu-item index="/banner">轮播管理</el-menu-item>
            <el-menu-item index="/home-recommend">首页推荐</el-menu-item>
            <el-menu-item index="/greenbook">绿书营销</el-menu-item> <!-- 新增 -->
          </el-sub-menu>


          <!-- 在营销中心后面添加预约管理菜单 -->
          <el-sub-menu index="reservation-group">
            <template #title>
              <el-icon>
                <Calendar />
              </el-icon>
              <span>预约管理</span>
            </template>
            <el-menu-item index="/reservation/form">预约表单</el-menu-item>
            <el-menu-item index="/reservation/record">预约记录</el-menu-item>
          </el-sub-menu>

          <!-- 7. 分销管理 -->
          <el-sub-menu index="distributor-group">
            <template #title>
              <el-icon>
                <Share />
              </el-icon>
              <span>分销管理</span>
            </template>
            <el-menu-item index="/marketing/distributor">分销员管理</el-menu-item>
            <el-menu-item index="/distributor-relation">分销关系</el-menu-item>
            <el-menu-item index="/invite-record">邀请记录</el-menu-item>
          </el-sub-menu>

          <!-- 8. 会员管理 -->
          <el-sub-menu index="member-group">
            <template #title>
              <el-icon>
                <User />
              </el-icon>
              <span>会员管理</span>
            </template>
            <el-menu-item index="/member/list">会员列表</el-menu-item>
            <el-menu-item index="/member/level">会员等级</el-menu-item>
            <el-menu-item index="/member-sign">会员签到</el-menu-item>
            <el-menu-item index="/member/coupon">优惠券管理</el-menu-item>
          </el-sub-menu>

          <!-- 9. 员工管理 -->
          <el-menu-item index="/staff">
            <el-icon>
              <UserFilled />
            </el-icon>
            <span>员工管理</span>
          </el-menu-item>

          <!-- 10. 系统设置 -->
          <!-- 系统设置 sub-menu 修改为 -->
          <el-sub-menu index="system-group">
            <template #title>
              <el-icon>
                <Setting />
              </el-icon>
              <span>系统设置</span>
            </template>
            <el-menu-item index="/profile">个人中心</el-menu-item>
            <el-menu-item index="/channel-config">渠道配置</el-menu-item>
            <el-menu-item index="/pay-config">支付配置</el-menu-item>
            <el-menu-item index="/map-config">地图配置</el-menu-item>
            <el-menu-item index="/storage-config">存储配置</el-menu-item>
            <el-menu-item index="/ai-config">接口配置</el-menu-item>
            <el-menu-item index="/base-config">基础设置</el-menu-item>
          </el-sub-menu>

        </el-menu>
      </div>

      <div class="sidebar-footer" v-if="!isCollapsed">
        <div class="store-info">
          <el-icon>
            <OfficeBuilding />
          </el-icon>
          <span>{{ storeName }}</span>
        </div>
      </div>
    </aside>

    <!-- 主内容区 -->
    <div class="main-wrapper">
      <!-- 顶部导航 -->
      <header class="header">
        <div class="header-left">
          <el-icon class="collapse-icon" @click="toggleCollapse">
            <Fold v-if="!isCollapsed" />
            <Expand v-else />
          </el-icon>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute">{{ currentRoute }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="header-right">
          <div class="header-info">
            <div class="info-item" v-if="dianshu !== null">
              <el-icon>
                <Coin />
              </el-icon>
              <span class="info-value">{{ dianshu }} 点</span>
            </div>
            <div class="info-item" v-if="outDate">
              <el-icon>
                <Calendar />
              </el-icon>
              <span class="info-value" :class="{ 'expiring-soon': isExpiringSoon }">
                {{ formatOutDate }}
              </span>
            </div>
          </div>
          <el-badge :value="notificationCount" :hidden="notificationCount === 0" class="notification-badge">
            <el-icon class="header-icon" @click="goToOrder">
              <Bell />
            </el-icon>
          </el-badge>

          <el-dropdown trigger="click" @command="handleCommand">
            <div class="user-dropdown">
              <el-avatar :size="36" :src="userAvatar" class="user-avatar" />
              <span class="user-name">{{ userName }}</span>
              <el-icon>
                <ArrowDown />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">
                  <el-icon>
                    <User />
                  </el-icon>个人中心
                </el-dropdown-item>
                <el-dropdown-item command="password">
                  <el-icon>
                    <Lock />
                  </el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided command="logout">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </header>

      <!-- 内容区域 -->
      <main class="content">
        <div class="content-card">
          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </main>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog v-model="showPasswordDialog" title="修改密码" width="420px" class="custom-dialog">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-width="80px">
        <el-form-item label="旧密码" prop="oldPwd">
          <el-input v-model="passwordForm.oldPwd" type="password" placeholder="请输入旧密码" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="passwordForm.newPwd" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input v-model="passwordForm.confirmPwd" type="password" placeholder="请再次输入新密码" show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="submitPassword" :loading="passwordLoading">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import axios from 'axios'
import config from '@/config'

const router = useRouter()
const route = useRoute()
const shopLogo = ref('@/assets/logo.png') // 默认logo
const shopName = ref('商户端') // 默认名称
// 侧边栏状态
const isCollapsed = ref(false)

// 在 setup() 中声明
const dianshu = ref(null)
const outDate = ref('')

// 用户信息
const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
const userName = ref(userInfo.account || '管理员')
const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
const storeName = ref(userInfo.nickName)
const notificationCount = ref(0)

// 定时器ID
let timerId = null

// 当前路由标题
const currentRoute = computed(() => {
  const matched = route.matched
  if (matched.length > 1) {
    return matched[matched.length - 1].meta?.title || matched[matched.length - 1].name
  }
  return ''
})

// 激活的菜单项
const activeMenu = computed(() => route.path)

// 修改密码相关
const showPasswordDialog = ref(false)
const passwordLoading = ref(false)
const passwordFormRef = ref(null)
const passwordForm = ref({
  oldPwd: '',
  newPwd: '',
  confirmPwd: ''
})

const passwordRules = {
  oldPwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
  newPwd: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
  ],
  confirmPwd: [
    { required: true, message: '请确认新密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== passwordForm.value.newPwd) {
          callback(new Error('两次输入密码不一致'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ]
}

// 计算过期时间显示和样式
const formatOutDate = computed(() => {
  if (!outDate.value) return ''
  const date = new Date(outDate.value)
  return `过期: ${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
})

const isExpiringSoon = computed(() => {
  if (!outDate.value) return false
  const now = new Date()
  const expire = new Date(outDate.value)
  const daysLeft = Math.ceil((expire - now) / (1000 * 60 * 60 * 24))
  return daysLeft <= 30 && daysLeft > 0
})

// 修改 fetchNotificationCount 函数，同时获取点数和过期时间
const fetchUserInfo = async () => {
  try {
    const agentId = userInfo.agent_id || 0
    const storeId = userInfo.id

    const response = await axios.get(`${config.BASE_URL}/shop/api/profile_api.php`, {
      params: {
        agent_id: agentId,
        store_id: storeId
      }
    })

    if (response.data.code === 200 && response.data.data) {
      dianshu.value = response.data.data.dianshu || 0
      outDate.value = response.data.data.out_date || ''

      // 更新 userInfo
      const updatedInfo = { ...userInfo, ...response.data.data }
      Cookies.set('user_info', JSON.stringify(updatedInfo), { expires: 7 })
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
  }
}

// 获取通知数量（待处理订单数）
const fetchNotificationCount = async () => {
  try {
    const agentId = userInfo.agent_id || 0
    const storeId = userInfo.id

    const response = await axios.get(`${config.BASE_URL}/shop/api/order_api.php`, {
      params: {
        agent_id: agentId,
        store_id: storeId,
        page: 1,
        limit: 100
      }
    })

    if (response.data.code === 200 && response.data.data.list) {
      const orders = response.data.data.list
      const pendingPayCount = orders.filter(order => order.pay_status === 0 && order.order_status === 0).length
      const pendingUseCount = orders.filter(order => order.pay_status === 1 && order.order_status === 1).length
      notificationCount.value = pendingPayCount + pendingUseCount
    } else if (response.data.code === 200 && response.data.data.stats) {
      const stats = response.data.data.stats
      notificationCount.value = (stats.pending_pay || 0) + (stats.pending_use || 0)
    } else {
      notificationCount.value = 0
    }
  } catch (error) {
    console.error('获取通知数量失败:', error)
    notificationCount.value = 0
  }
}

// 跳转到订单页面
const goToOrder = () => {
  router.push('/order')
}

// 切换侧边栏
const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value
}

// 下拉菜单命令
const handleCommand = (command) => {
  switch (command) {
    case 'profile':
      router.push('/profile')
      break
    case 'password':
      showPasswordDialog.value = true
      break
    case 'logout':
      handleLogout()
      break
  }
}

// 退出登录
const handleLogout = async () => {
  try {
    await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    Cookies.remove('user_token')
    Cookies.remove('user_info')
    router.push('/login')
    ElMessage.success('已退出登录')
  } catch (error) {
    // 取消退出
  }
}

// 修改密码
const submitPassword = async () => {
  if (!passwordFormRef.value) return

  await passwordFormRef.value.validate(async (valid) => {
    if (!valid) return

    passwordLoading.value = true
    try {
      const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
        action: 'update_password',
        account: userInfo.account,
        old_password: passwordForm.value.oldPwd,
        new_password: passwordForm.value.newPwd
      })

      if (response.data.success) {
        ElMessage.success('密码修改成功，请重新登录')
        showPasswordDialog.value = false
        setTimeout(() => {
          handleLogout()
        }, 1500)
      } else {
        ElMessage.error(response.data.message || '密码修改失败')
      }
    } catch (error) {
      ElMessage.error('请求失败，请稍后重试')
    } finally {
      passwordLoading.value = false
    }
  })
}

// 加载店铺信息
const loadShopInfo = async () => {
  try {
    // 获取当前域名
    const currentDomain = window.location.hostname;

    // 通过 URL 参数传递域名，而不是请求头
    const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`, {
      params: {
        domain: currentDomain
      }
    })

    if (response.data.success) {
      shopLogo.value = response.data.data.shop_logo || '@/assets/logo.gif'
      shopName.value = response.data.data.shop_name || '商户端'
    }
  } catch (error) {
    console.error('加载店铺信息失败:', error)
    // 使用默认值
    shopLogo.value = '@/assets/logo.gif'
    shopName.value = '商户端'
  }
}

onMounted(() => {
  loadShopInfo() // 新增：加载店铺信息
  fetchNotificationCount()
  fetchUserInfo()  // 新增
  timerId = setInterval(() => {
    fetchNotificationCount()
  }, 30000)
})

onUnmounted(() => {
  if (timerId) {
    clearInterval(timerId)
  }
})
</script>

<style scoped lang="scss">
.app-layout {
  display: flex;
  min-height: 100vh;
  background: #f0f2f6;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 20px;
  padding-right: 20px;
  border-right: 1px solid #e8e8e8;

  .info-item {
    display: flex;
    align-items: center;
    gap: 6px;

    .el-icon {
      font-size: 18px;
      color: #409eff;
    }

    .info-value {
      font-size: 14px;
      color: #333;
      font-weight: 500;

      &.expiring-soon {
        color: #f56c6c;
      }
    }
  }
}

// 侧边栏样式
.sidebar {
  width: 260px;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  overflow: hidden;

  &.sidebar-collapsed {
    width: 64px;

    .logo-text {
      display: none;
    }

    .store-info span {
      display: none;
    }
  }

  .logo-area {
    display: flex;
    align-items: center;
    padding: 20px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;

    .logo-img {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      flex-shrink: 0;
    }

    .logo-text {
      margin-left: 12px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      white-space: nowrap;
    }
  }

  // 菜单滚动区域
  .sidebar-menu-wrapper {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;

    // 自定义滚动条样式
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 4px;

      &:hover {
        background: rgba(255, 255, 255, 0.5);
      }
    }
  }

  .sidebar-menu {
    border: none;
    background: transparent !important;
    padding: 16px 12px;

    &:not(.el-menu--collapse) {
      width: 100%;
    }

    :deep(.el-menu) {
      background: transparent !important;
    }

    :deep(.el-menu-item),
    :deep(.el-sub-menu .el-sub-menu__title) {
      height: 48px;
      line-height: 48px;
      color: rgba(255, 255, 255, 0.7);
      border-radius: 12px;
      margin-bottom: 4px;
      background: transparent !important;

      &:hover {
        background: rgba(255, 255, 255, 0.1) !important;
        color: #fff;
      }

      &.is-active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        color: #fff;
      }

      .el-icon {
        font-size: 20px;
        margin-right: 12px;
      }
    }

    :deep(.el-sub-menu) {
      .el-menu {
        background: transparent !important;
      }

      .el-menu-item {
        padding-left: 52px !important;
        background: transparent !important;

        &:hover {
          background: rgba(255, 255, 255, 0.08) !important;
        }

        &.is-active {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        }
      }
    }

    :deep(.el-popper) {
      .el-menu--popup {
        background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%) !important;
        border: none;

        .el-menu-item {
          background: transparent !important;
          color: rgba(255, 255, 255, 0.7);

          &:hover {
            background: rgba(255, 255, 255, 0.1) !important;
            color: #fff;
          }

          &.is-active {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
            color: #fff;
          }
        }
      }
    }
  }

  .sidebar-footer {
    padding: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;

    .store-info {
      display: flex;
      align-items: center;
      color: rgba(255, 255, 255, 0.6);
      font-size: 13px;

      .el-icon {
        margin-right: 8px;
        font-size: 16px;
      }

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

// 主内容区样式
.main-wrapper {
  flex: 1;
  margin-left: 260px;
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .sidebar-collapsed~& {
    margin-left: 64px;
  }
}

// 头部样式
.header {
  height: 60px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: sticky;
  top: 0;
  z-index: 99;

  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;

    .collapse-icon {
      font-size: 20px;
      cursor: pointer;
      color: #666;
      transition: all 0.3s;

      &:hover {
        color: #667eea;
      }
    }

    :deep(.el-breadcrumb) {
      font-size: 14px;

      .el-breadcrumb__inner {
        color: #666;

        &.is-link:hover {
          color: #667eea;
        }
      }

      .el-breadcrumb__item:last-child .el-breadcrumb__inner {
        color: #333;
        font-weight: 500;
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 24px;

    .notification-badge {
      cursor: pointer;

      :deep(.el-badge__content) {
        background-color: #f56c6c;
      }
    }

    .header-icon {
      font-size: 20px;
      color: #666;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        color: #667eea;
      }
    }

    .user-dropdown {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      padding: 4px 12px;
      border-radius: 24px;
      transition: background 0.3s;

      &:hover {
        background: #f5f5f5;
      }

      .user-avatar {
        border: 2px solid #e0e0e0;
      }

      .user-name {
        font-size: 14px;
        color: #333;
      }

      .el-icon {
        font-size: 16px;
        color: #999;
      }
    }
  }
}

// 内容区域样式
.content {
  padding: 24px;
  min-height: calc(100vh - 60px);

  .content-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    padding: 24px;
    min-height: calc(100vh - 108px);
  }
}

// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// 响应式
@media (max-width: 768px) {
  .sidebar {
    width: 64px;

    .logo-text,
    .store-info span {
      display: none;
    }
  }

  .main-wrapper {
    margin-left: 64px;
  }

  .header {
    padding: 0 16px;

    .user-dropdown .user-name {
      display: none;
    }
  }

  .content {
    padding: 16px;

    .content-card {
      padding: 16px;
    }
  }
}
</style>